var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import Service from '../../services/Service';
import StepForm from '../../components/StepForm';
import StepRead from '../../components/StepRead';
import StepImage from '../../components/StepImage';
import StepSelfie from '../../components/StepSelfie';
import StepDecision from '../../components/StepDecision';
import { isDocumentDecision } from '../../components/StepDecision/documentSubmissionIntro';
import StepConfirmation from '../../components/StepConfirmation';
import { SampleApp } from '../../liveness/react-ts-liveness';
import StepLivenessReact from '../../components/StepLivenessReact';
import StepLivenessLocal from '../../components/StepLivenessLocal';
import StepSuccess from '../../components/StepSuccess';
import StepPasskey from '../../components/StepPasskey';
import { ToastContainer, toast } from 'react-toastify';
import Loading from '../../components/Loading';
import TopNavigation from '../../components/TopNavigation';
import WelcomeScreen from '../../components/WelcomeScreen';
import * as FormActions from '../../store/form/actions';
import * as LoaderActions from '../../store/loader/actions';
import * as ThemeActions from '../../store/theme/actions';
import * as NavigationActions from '../../store/navigation/actions';
import { canSkipTokenSearchForCnpjDecision, isCnpjOcrDecision, } from '../../util/CnpjOcrFlow';
import { useTranslation } from '../../i18n';
import { Container, ErrorText, LivenessInfoMainContainer, BeforeLivenessContainer, InfosContainer, InfosTitle, InfosBeforeLiveness, InfosListBeforeLiveness, ButtonBeforeLiveness } from './styles';
import StepLivenessAWS from '../../components/StepLivenessAWS';
import StepResult from '../../components/StepResult';
var FormPage = function () {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var location = useLocation();
    var t = useTranslation().t;
    var searchParams = useSearchParams()[0];
    var locationState = location.state;
    var externalToken = (locationState === null || locationState === void 0 ? void 0 : locationState.tokenOnboarding)
        || searchParams.get('token')
        || searchParams.get('tokenOnboarding');
    var useEnrichedPasskey = React.useRef(Boolean(externalToken));
    var _a = (location && location.state) ? location.state : { clientId: null, step: 1, redirect: false, tokenOnboarding: null, serviceAlias: null, fieldAlias: null, countSteps: null }, _b = _a.step, step = _b === void 0 ? 1 : _b, clientId = _a.clientId, tokenOnboarding = _a.tokenOnboarding, serviceAlias = _a.serviceAlias, fieldAlias = _a.fieldAlias, countSteps = _a.countSteps, redirect = _a.redirect;
    if (tokenOnboarding) {
        localStorage.setItem('tokenOnboarding', tokenOnboarding);
    }
    else {
        tokenOnboarding = localStorage.getItem('tokenOnboarding');
    }
    if (tokenOnboarding !== null) {
        Sentry.setUser({ id: tokenOnboarding });
    }
    if (clientId) {
        localStorage.setItem('clientId', clientId);
    }
    else {
        clientId = localStorage.getItem('clientId');
    }
    if (clientId === "royal-benk") {
        document.body.style.backgroundColor = '#000000';
    }
    if (clientId === null || clientId === void 0 ? void 0 : clientId.includes("royal-benk")) {
        document.body.style.color = '#000000';
    }
    var _c = useSelector(function (state) { return state.form; }), form = _c.form, formInfo = _c.formInfo;
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var allowBackNavigation = useSelector(function (state) { return state.navigation; }).allowBackNavigation;
    // Query visual topology separately: the first-step response can omit branches
    // and the success node. Never replace the operational form with this result.
    React.useEffect(function () {
        var token = formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding;
        var product = formInfo === null || formInfo === void 0 ? void 0 : formInfo.productName;
        if (!token || !product)
            return;
        var active = true;
        Service.searchByToken(token, product).then(function (response) {
            var _a;
            var configuration = (_a = response.onboardingDTO) === null || _a === void 0 ? void 0 : _a.onboardingForm;
            if (active && configuration)
                dispatch(FormActions.setProgressForm(configuration));
        }).catch(function () { });
        return function () { active = false; };
    }, [formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding, formInfo === null || formInfo === void 0 ? void 0 : formInfo.productName]);
    var _d = React.useState(false), error = _d[0], setError = _d[1];
    var _e = React.useState(t('errors.fetchParams')), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = React.useState(false), loading = _f[0], setLoading = _f[1];
    var _g = React.useState(null), decisionError = _g[0], setDecisionError = _g[1];
    var _h = React.useState(true), isShowingLivenessInfo = _h[0], setIsShowingLivenessInfo = _h[1];
    var trustedPasskeyDecision = React.useRef(null);
    var stepIndex = 0;
    if ((form === null || form === void 0 ? void 0 : form.steps) && Array.isArray(form.steps)) {
        stepIndex = form.steps.findIndex(function (formStep) { return formStep.step === step; });
        if (stepIndex < 0) {
            stepIndex = 0;
        }
    }
    var stepSearch = function () {
        if (tokenOnboarding && serviceAlias && countSteps && fieldAlias) {
            Service.stepSearch({
                tokenOnboarding: tokenOnboarding,
                serviceAlias: serviceAlias,
                fieldAlias: fieldAlias,
            }).then(function (response) {
                if (countSteps) {
                    var nextForm = {
                        countSteps: countSteps,
                        steps: response.onboardingForm.steps,
                    };
                    dispatch(FormActions.setForm(nextForm));
                }
                if (tokenOnboarding)
                    dispatch(FormActions.setFormInfo({ tokenOnboarding: tokenOnboarding, productName: clientId }));
                if (response.onboardingForm.steps[stepIndex] && response.onboardingForm.steps[stepIndex].type === "LIVENESS_3D") {
                    startLiveness({ countSteps: countSteps, steps: response.onboardingForm.steps }, { tokenOnboarding: tokenOnboarding, productName: clientId }, theme, navigate, dispatch, setLoading, isShowingLivenessInfo);
                }
            }).catch(function () {
                setError(true);
            });
        }
    };
    var getOnboardingToken = function (token) {
        if (token === void 0) { token = null; }
        var product = clientId;
        if (!product) {
            var url = new URL(window.location.href);
            var origin_1 = url.origin;
            product = origin_1.replace(".idcerberus.com", "").replace("-dev", "").replace("https://", "").replace("http://", "").split("/")[0];
            if (origin_1.includes("sdk") || origin_1.includes('localhost') || origin_1.includes('192.168')) {
                product = searchParams.get('product');
            }
        }
        ;
        if (product) {
            localStorage.setItem('clientId', product);
        }
        if (!product) {
            setErrorMessage(t('errors.productNotFound'));
            setError(true);
            return;
        }
        if (product.includes("royal-benk")) {
            document.body.style.color = '#000000';
        }
        Service.getOnboardingToken({ clientId: product.trim() || '' }, token)
            .then(function (response) {
            if (response) {
                if (response === null || response === void 0 ? void 0 : response.tokenOnboarding) {
                    localStorage.setItem('tokenOnboarding', response === null || response === void 0 ? void 0 : response.tokenOnboarding);
                }
                dispatch(FormActions.setFormInfo({
                    tokenOnboarding: response === null || response === void 0 ? void 0 : response.tokenOnboarding,
                    productName: product
                }));
                getFormParams(response.tokenOnboarding);
            }
            else {
                setError(true);
            }
        })
            .catch(function (error) {
            var _a;
            setError(true);
            if (((_a = error.data) === null || _a === void 0 ? void 0 : _a.errorKey) === 'insufficientBalance') {
                setErrorMessage(t('errors.insufficientBalance'));
                return;
            }
            setErrorMessage(t('errors.onboardingTokenFailed'));
        });
    };
    var getFormParams = function (tokenOnboarding) {
        var product = clientId;
        if (!product) {
            navigate('/');
        }
        Service.getFirstStep({
            clientId: product || '',
            tokenOnboarding: useEnrichedPasskey.current ? tokenOnboarding : undefined,
        })
            .then(function (response) {
            if (response) {
                dispatch(FormActions.setForm(response.onboardingForm));
                response.style.defaultTheme = false;
                if (response.style.logo) {
                    var img = new Image();
                    img.onerror = function () {
                        response.style.logo = '';
                        dispatch(ThemeActions.updateTheme(response.style));
                    };
                    img.onload = function () {
                        dispatch(ThemeActions.updateTheme(response.style));
                    };
                    img.src = response.style.logo;
                }
                else {
                    if (!response.style.hideHeader) {
                        dispatch(ThemeActions.updateTheme(__assign(__assign({}, response.style), { logo: 'https://www.react-it.com/wp-content/uploads/2022/08/react-it-logo2.png' })));
                    }
                }
                if (response.onboardingForm.steps[stepIndex] && response.onboardingForm.steps[stepIndex].type === "LIVENESS_3D") {
                    startLiveness(response.onboardingForm, { tokenOnboarding: tokenOnboarding }, response.style, navigate, dispatch, setLoading, isShowingLivenessInfo);
                }
            }
        })
            .catch(function () {
            setError(true);
        });
    };
    var validateIfStepDone = function (tokenOnboarding, productName) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, onboardingDTO, numberSteps, activeStepIndex, steps, groups, stepIdentifier_1, expectedStep, skipped, _loop_1, i, expectedStepNum, state_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, Service.searchByToken(tokenOnboarding, productName)];
                case 1:
                    _a = _c.sent(), onboardingDTO = _a.onboardingDTO, numberSteps = _a.numberSteps;
                    if (onboardingDTO) {
                        activeStepIndex = numberSteps;
                        steps = onboardingDTO.onboardingForm.steps;
                        groups = steps.reduce(function (groups, current) {
                            var stepGroup = current.step.toString().includes('.')
                                ? current.step.toString().split('.')[0] + '.'
                                : current.step.toString();
                            if (!groups.includes(stepGroup)) {
                                return __spreadArray(__spreadArray([], groups, true), [stepGroup], false);
                            }
                            return groups;
                        }, []);
                        stepIdentifier_1 = groups[activeStepIndex];
                        if (stepIdentifier_1 === null || stepIdentifier_1 === void 0 ? void 0 : stepIdentifier_1.includes('.')) {
                            stepIdentifier_1 = groups[activeStepIndex - 1];
                        }
                        expectedStep = (_b = steps.find(function (step) { return step.step.toString() === stepIdentifier_1; })) === null || _b === void 0 ? void 0 : _b.step;
                        if (expectedStep && expectedStep.toString() !== step.toString() && !groups.includes(stepIdentifier_1 + '.')) {
                            if (Number(expectedStep) > (Number(step) + 1)) {
                                skipped = Number(expectedStep) - Number(step);
                                toast.info(t('flow.stepAlreadyDone', { count: skipped }), { autoClose: 3000 });
                            }
                            _loop_1 = function (i, expectedStepNum) {
                                var found = form.steps.find(function (formStep) { return formStep.step.toString() === expectedStepNum.toString(); });
                                if (!found) {
                                    dispatch(FormActions.setForm(onboardingDTO.onboardingForm));
                                    return "break";
                                }
                            };
                            for (i = 0, expectedStepNum = +expectedStep; i <= expectedStep; i++) {
                                state_1 = _loop_1(i, expectedStepNum);
                                if (state_1 === "break")
                                    break;
                            }
                            navigate('/form', { state: { step: expectedStep, redirect: false } });
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onPressConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var tokenOnboarding, productName, params, alreadyDone, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!formInfo) {
                        toast.error(t('errors.invalidOnboardingRetry'));
                        return [2 /*return*/];
                    }
                    tokenOnboarding = formInfo.tokenOnboarding, productName = formInfo.productName;
                    if (!tokenOnboarding || !productName) {
                        toast.error(t('errors.invalidOnboardingRetry'));
                        return [2 /*return*/];
                    }
                    if (!form.steps[stepIndex] || form.steps[stepIndex].type === 'CONFIRMATION')
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setLoading(true);
                    params = {
                        onboardingForm: {
                            countSteps: form.countSteps,
                            steps: [__assign({}, form.steps[stepIndex])],
                        },
                        tokenOnboarding: (formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || '',
                    };
                    params.onboardingForm.steps[0].fields = params.onboardingForm.steps[0].fields.filter(function (field) { return !!field.value; });
                    return [4 /*yield*/, validateIfStepDone(tokenOnboarding, productName)];
                case 2:
                    alreadyDone = _a.sent();
                    if (!alreadyDone) {
                        dispatch(LoaderActions.show(true));
                        Service.saveStep(params)
                            .then(function (response) {
                            dispatch(LoaderActions.show(false));
                            if (response) {
                                dispatch(FormActions.addFormStep(response));
                                var newStep = response.steps[0].step;
                                navigate('/form', { state: { step: newStep, redirect: redirect } });
                                setLoading(false);
                            }
                        })
                            .catch(function () {
                            dispatch(LoaderActions.show(false));
                            setError(true);
                            setErrorMessage(t('errors.invalidOnboarding'));
                            setLoading(false);
                        });
                    }
                    else {
                        setLoading(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    toast.error(t('errors.generic'));
                    setLoading(false);
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onCompletePasskey = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var currentStep, alreadyDone, resultFields, params, response, nextStep;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || !formInfo.productName) {
                        throw new Error(t('errors.invalidOnboardingRetry'));
                    }
                    currentStep = form.steps[stepIndex];
                    if (!currentStep || currentStep.type !== 'PASSKEY') {
                        throw new Error(t('errors.passkeyStepInvalid'));
                    }
                    setLoading(true);
                    dispatch(LoaderActions.show(true));
                    trustedPasskeyDecision.current = null;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 4, 5]);
                    return [4 /*yield*/, validateIfStepDone(formInfo.tokenOnboarding, formInfo.productName)];
                case 2:
                    alreadyDone = _b.sent();
                    if (alreadyDone)
                        return [2 /*return*/];
                    resultFields = Object.entries(result).map(function (_a) {
                        var field = _a[0], value = _a[1];
                        var configuredField = currentStep.fields.find(function (item) { return item.field === field; });
                        return {
                            field: field,
                            label: (configuredField === null || configuredField === void 0 ? void 0 : configuredField.label) || field,
                            placeholder: (configuredField === null || configuredField === void 0 ? void 0 : configuredField.placeholder) || '',
                            minSize: (configuredField === null || configuredField === void 0 ? void 0 : configuredField.minSize) || 0,
                            maxSize: (configuredField === null || configuredField === void 0 ? void 0 : configuredField.maxSize) || value.length,
                            type: (configuredField === null || configuredField === void 0 ? void 0 : configuredField.type) || 'TEXT',
                            value: value,
                            required: (configuredField === null || configuredField === void 0 ? void 0 : configuredField.required) || false,
                            enabled: false,
                            valid: true,
                            nextStep: (configuredField === null || configuredField === void 0 ? void 0 : configuredField.nextStep) || false,
                            visible: false,
                        };
                    });
                    params = {
                        onboardingForm: {
                            countSteps: form.countSteps,
                            steps: [__assign(__assign({}, currentStep), { fields: resultFields })],
                        },
                        tokenOnboarding: formInfo.tokenOnboarding,
                    };
                    return [4 /*yield*/, Service.saveStep(params)];
                case 3:
                    response = _b.sent();
                    if (!((_a = response === null || response === void 0 ? void 0 : response.steps) === null || _a === void 0 ? void 0 : _a[0])) {
                        throw new Error(t('errors.passkeyInvalidResponse'));
                    }
                    nextStep = response.steps[0];
                    trustedPasskeyDecision.current = isCnpjOcrDecision(nextStep)
                        ? {
                            source: 'PASSKEY_PUT',
                            tokenOnboarding: formInfo.tokenOnboarding,
                            step: nextStep.step,
                            stepName: nextStep.stepName,
                        }
                        : null;
                    dispatch(FormActions.addFormStep(response));
                    navigate('/form', { state: { step: nextStep.step, redirect: redirect } });
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(LoaderActions.show(false));
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onPressField = function (field) { return __awaiter(void 0, void 0, void 0, function () {
        var handoffStage, tokenOnboarding, productName, currentStep, isDocumentSelection, skipTokenSearch, alreadyDone, _a, params, response, err_1, detail;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setDecisionError(null);
                    handoffStage = 'validar cadastro';
                    if (!formInfo) {
                        toast.error(t('errors.invalidOnboardingRetry'));
                        return [2 /*return*/];
                    }
                    tokenOnboarding = formInfo.tokenOnboarding, productName = formInfo.productName;
                    if (!tokenOnboarding || !productName) {
                        toast.error(t('errors.invalidOnboardingRetry'));
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, 8, 9]);
                    setLoading(true);
                    currentStep = form.steps[stepIndex];
                    isDocumentSelection = (currentStep === null || currentStep === void 0 ? void 0 : currentStep.type) === 'DECISION'
                        && isDocumentDecision(currentStep)
                        && currentStep.fields.some(function (item) { return item.field === field.field; });
                    skipTokenSearch = isDocumentSelection || canSkipTokenSearchForCnpjDecision(trustedPasskeyDecision.current, tokenOnboarding, currentStep, field);
                    // A confianca vale para uma unica selecao. Em falhas ambiguas, a proxima
                    // tentativa volta a sincronizar o progresso com o backend.
                    trustedPasskeyDecision.current = null;
                    if (!skipTokenSearch) return [3 /*break*/, 2];
                    _a = false;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, validateIfStepDone(tokenOnboarding, productName)];
                case 3:
                    _a = _c.sent();
                    _c.label = 4;
                case 4:
                    alreadyDone = _a;
                    if (!!alreadyDone) return [3 /*break*/, 6];
                    params = {
                        onboardingForm: {
                            countSteps: form.countSteps,
                            steps: [__assign(__assign({}, currentStep), { fields: [field] })],
                        },
                        tokenOnboarding: (formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || '',
                    };
                    dispatch(LoaderActions.show(true));
                    handoffStage = 'salvar escolha do documento';
                    return [4 /*yield*/, Service.saveStep(params)];
                case 5:
                    response = _c.sent();
                    handoffStage = 'receber etapa de captura';
                    if (!((_b = response === null || response === void 0 ? void 0 : response.steps) === null || _b === void 0 ? void 0 : _b.length))
                        throw new Error('O servidor não retornou a próxima etapa.');
                    if (String(response.steps[0].step) === String(currentStep.step)) {
                        throw new Error('O servidor retornou a mesma etapa de escolha do documento.');
                    }
                    handoffStage = 'abrir próxima etapa';
                    dispatch(FormActions.addFormStep(response));
                    navigate('/form', { state: { step: response.steps[0].step, redirect: redirect } });
                    _c.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    err_1 = _c.sent();
                    console.error('Document decision handoff failed:', err_1);
                    detail = err_1 instanceof Error && err_1.message !== 'Missing next step' ? err_1.message : '';
                    setDecisionError([t('camera.decisionFailed'), detail].filter(Boolean).join(' '));
                    if (isDocumentDecision(form.steps[stepIndex])) {
                        window.alert("Envio de documentos: falha ao ".concat(handoffStage, ".\n").concat(detail || t('camera.decisionFailed')));
                    }
                    return [3 /*break*/, 9];
                case 8:
                    dispatch(LoaderActions.show(false));
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var handleOkClickBeforeLiveness = function () {
        setIsShowingLivenessInfo(false);
        startLiveness(form, formInfo, theme, navigate, dispatch, setLoading, false);
    };
    var renderLivenessInfo = function () {
        var _a, _b, _c, _d;
        return (React.createElement(LivenessInfoMainContainer, null,
            React.createElement(TopNavigation, { showLogo: true, showBackButton: (_a = form.steps[stepIndex]) === null || _a === void 0 ? void 0 : _a.goBack, title: ((_b = form.steps[stepIndex]) === null || _b === void 0 ? void 0 : _b.showStepName) ? (_c = form.steps[stepIndex]) === null || _c === void 0 ? void 0 : _c.stepName : '', headerTransparent: (_d = form.steps[stepIndex]) === null || _d === void 0 ? void 0 : _d.headerTransparent, headerPadding: theme.logoPosition !== "header" ? 1 : 0 }),
            React.createElement(BeforeLivenessContainer, null,
                React.createElement(InfosTitle, null, t('liveness.title')),
                React.createElement(InfosContainer, null,
                    React.createElement(InfosBeforeLiveness, null, t('liveness.intro')),
                    React.createElement(InfosListBeforeLiveness, null,
                        React.createElement("li", { dangerouslySetInnerHTML: { __html: t('liveness.tipLighting') } }),
                        React.createElement("li", { dangerouslySetInnerHTML: { __html: t('liveness.tipAccessories') } }),
                        React.createElement("li", null, t('liveness.tipCentered'))),
                    React.createElement(InfosBeforeLiveness, null, t('liveness.outro'))),
                React.createElement(ButtonBeforeLiveness, { onClick: handleOkClickBeforeLiveness }, t('common.continue')))));
    };
    var startLiveness = function (form, formInfo, theme, navigate, dispatch, setLoading, showingLivenessInfo) { return __awaiter(void 0, void 0, void 0, function () {
        var isValid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (stepIndex < 0) {
                        return [2 /*return*/, React.createElement(Loading, null)];
                    }
                    if (!showingLivenessInfo) return [3 /*break*/, 1];
                    return [2 /*return*/, renderLivenessInfo()];
                case 1:
                    if (!theme.secondaryLogo) return [3 /*break*/, 3];
                    return [4 /*yield*/, Service.checkIfImageIsValid(theme.secondaryLogo)];
                case 2:
                    isValid = _a.sent();
                    if (!isValid) {
                        // Secondary Logo quebrada
                        dispatch(ThemeActions.updateTheme(__assign(__assign({}, theme), { secondaryLogo: undefined })));
                        SampleApp.onLivenessCheckPressed(form, stepIndex, formInfo, __assign(__assign({}, theme), { secondaryLogo: undefined }), navigate, dispatch, setLoading);
                        return [2 /*return*/];
                    }
                    _a.label = 3;
                case 3:
                    SampleApp.onLivenessCheckPressed(form, stepIndex, formInfo, theme, navigate, dispatch, setLoading);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var searchByToken = function (tokenOnboarding, clientId) {
        Service.searchByToken(tokenOnboarding, clientId)
            .then(function (response) {
            var _a, _b, _c, _d;
            var onboardingForm = (_a = response.onboardingDTO) === null || _a === void 0 ? void 0 : _a.onboardingForm;
            var theme = (_b = response.onboardingDTO) === null || _b === void 0 ? void 0 : _b.style;
            if (onboardingForm && theme) {
                var status_1 = response.status;
                var shouldLoadEnrichedPasskey = useEnrichedPasskey.current
                    && status_1 === "IN_PROCESS"
                    && response.numberSteps === 0
                    && ((_c = onboardingForm.steps[0]) === null || _c === void 0 ? void 0 : _c.type) === "PASSKEY";
                if (shouldLoadEnrichedPasskey) {
                    dispatch(FormActions.setFormInfo({ tokenOnboarding: tokenOnboarding, productName: clientId }));
                    getFormParams(tokenOnboarding);
                    return;
                }
                if (status_1 === "IN_PROCESS" && response.onboardingDTO) {
                    dispatch(FormActions.setForm(onboardingForm));
                    dispatch(FormActions.setFormInfo({ tokenOnboarding: tokenOnboarding, productName: clientId }));
                    dispatch(ThemeActions.updateTheme(theme));
                    var activeStepIndex = response.numberSteps;
                    var steps = response.onboardingDTO.onboardingForm.steps;
                    var groups = steps.reduce(function (groups, current) {
                        var stepGroup = current.step.toString().includes('.')
                            ? current.step.toString().split('.')[0] + '.'
                            : current.step.toString();
                        if (!groups.includes(stepGroup)) {
                            return __spreadArray(__spreadArray([], groups, true), [stepGroup], false);
                        }
                        return groups;
                    }, []);
                    var stepIdentifier_2 = groups[activeStepIndex];
                    if (stepIdentifier_2.includes('.')) {
                        stepIdentifier_2 = groups[activeStepIndex - 1];
                    }
                    navigate('/form', { state: { step: (_d = steps.find(function (step) { return step.step.toString() === stepIdentifier_2; })) === null || _d === void 0 ? void 0 : _d.step, redirect: redirect } });
                }
                else if (status_1 === "APPROVED" || status_1 === "ANALYZING" || status_1 === "REFUSED" || status_1 === "WAITING_MANUAL" || status_1 === "WAITING_PRE_REQUISITS") {
                    setErrorMessage(t('errors.onboardingAlreadyFinished'));
                    setError(true);
                }
                else if (status_1 === "CANCELED") {
                    setErrorMessage(t('errors.tokenCanceled'));
                    setError(true);
                }
                else {
                    getOnboardingToken(useEnrichedPasskey.current ? tokenOnboarding : null);
                }
            }
            else {
                getOnboardingToken(useEnrichedPasskey.current ? tokenOnboarding : null);
            }
        })
            .catch(function (err) {
            console.error('err: ', err);
            toast.error(t('errors.invalidToken'));
            getOnboardingToken(useEnrichedPasskey.current ? tokenOnboarding : null);
        });
    };
    React.useEffect(function () {
        var handlePopstate = function (event) {
            if (!allowBackNavigation) {
                event.preventDefault();
                window.location.replace(window.location.href);
            }
            else {
                if (form.steps.length > 0) {
                    var newForm = __assign({}, form);
                    newForm.steps.pop();
                    dispatch(FormActions.setForm(newForm));
                }
                dispatch(NavigationActions.setAllowBackNavigation(false));
            }
        };
        window.addEventListener('popstate', handlePopstate);
        return function () {
            window.removeEventListener('popstate', handlePopstate);
        };
    }, [allowBackNavigation]);
    React.useEffect(function () {
        if (form.steps.length === 0) {
            if (tokenOnboarding && serviceAlias) {
                stepSearch();
            }
            else if (tokenOnboarding && clientId) {
                searchByToken(tokenOnboarding, clientId);
            }
            else {
                getOnboardingToken(tokenOnboarding);
            }
        }
    }, []);
    React.useEffect(function () {
        var _a;
        if (((_a = form.steps[stepIndex]) === null || _a === void 0 ? void 0 : _a.type) === 'LIVENESS_3D') {
            startLiveness(form, formInfo, theme, navigate, dispatch, setLoading, isShowingLivenessInfo);
        }
    }, [step]);
    React.useEffect(function () {
        if (window && window.top) {
            if (step === 1) {
                window.top.postMessage(JSON.stringify({ status: 'initial', tokenOnboarding: formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding }), '*');
            }
            else if (form.countSteps !== 0 && step === form.countSteps) {
                window.top.postMessage(JSON.stringify({ status: 'success', tokenOnboarding: formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding }), '*');
            }
            else {
                window.top.postMessage(JSON.stringify({ status: 'middle', tokenOnboarding: formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding }), '*');
            }
        }
    }, [step]);
    if (error) {
        return (React.createElement(Container, null,
            React.createElement(ErrorText, null, errorMessage)));
    }
    if (form.steps.length === 0 || theme.defaultTheme)
        return React.createElement(React.Fragment, null);
    if (!form.steps[0])
        return React.createElement(Loading, null);
    if (!form.steps[stepIndex])
        return React.createElement(Loading, null);
    if (!form.steps[0].type)
        return React.createElement(Loading, null);
    if (!form.steps[stepIndex].type)
        return React.createElement(Loading, null);
    if (form.steps[stepIndex].type === 'LIVENESS_3D' && loading)
        return React.createElement(Loading, null);
    return (React.createElement(React.Fragment, null,
        React.createElement(ToastContainer, null),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'WELCOME' && (React.createElement(WelcomeScreen, { step: stepIndex, onContinue: onPressConfirm })),
        isShowingLivenessInfo && form.steps[stepIndex] && form.steps[stepIndex].type === 'LIVENESS_3D' && renderLivenessInfo(),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'READ' && React.createElement(StepRead, { step: stepIndex, onPressConfirm: onPressConfirm, loading: loading }),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'CONFIRMATION' && React.createElement(StepConfirmation, { step: stepIndex }),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'FORM' && React.createElement(StepForm, { step: stepIndex, onPressConfirm: onPressConfirm, loading: loading }),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'SELFIE' && React.createElement(StepSelfie, { step: stepIndex }),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'DECISION' && React.createElement(StepDecision, { step: stepIndex, loading: loading, onPressField: onPressField, errorMessage: decisionError }),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'IMAGE' && React.createElement(StepImage, { step: stepIndex }),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'LIVENESS_3D_AWS' && (React.createElement(StepLivenessAWS, { step: stepIndex, loading: loading, onPressConfirm: onPressConfirm })),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'LIVENESS_3D_REACT' && React.createElement(StepLivenessReact, { step: stepIndex }),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'LIVENESS_LOCAL' && React.createElement(StepLivenessLocal, { step: stepIndex }),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'SUCCESS' && React.createElement(StepSuccess, { step: stepIndex }),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'PASSKEY' && (React.createElement(StepPasskey, { key: form.steps[stepIndex].step, step: stepIndex, saving: loading, useEnrichedData: useEnrichedPasskey.current, onComplete: onCompletePasskey })),
        form.steps[stepIndex] && form.steps[stepIndex].type === 'RESULT' && React.createElement(StepResult, { step: stepIndex })));
};
export default FormPage;
